export class RemoveFormAction {
  public static readonly type = '[Project/Forms/List] RemoveFormAction';
  constructor(public readonly id: string) {}
}
